export default function FaqSection() {
  return (
    <section className="sec">
      <div className="wrap">
        <div className="faqw">
          <div className="l rv">
            <small style={{ display: "block", fontSize: "16px", fontWeight: "600", color: "var(--t4)", marginBottom: "12px" }}>
              도입 전 궁금한 점부터
            </small>
            <h2>자주 묻는 질문</h2>
          </div>
          <div className="faq rv d1">
            <details open>
              <summary>
                <b>01</b>
                도입 전 테스트나 체험이 가능한가요?
                <svg className="i">
                  <use href="#chev" />
                </svg>
              </summary>
              <div className="a">
                네, 바로 사용해볼 수 있는 테스트 환경을 제공합니다. 간단한 체험 신청서를 작성하면 최대 2주 동안 회사의 테스트용 데이터를 연결해 AI Agent가 업무에 잘 맞는지 확인할 수 있습니다.
              </div>
            </details>
            <details>
              <summary>
                <b>02</b>
                개발 지식이 없어도 AI Agent를 만들 수 있나요?
                <svg className="i">
                  <use href="#chev" />
                </svg>
              </summary>
              <div className="a">
                네, 전문적인 개발 지식이 없어도 AI Agent를 만들 수 있습니다. 화면에서 필요한 기능을 선택하고 연결하는 방식으로 구성할 수 있어, 복잡한 코드를 직접 작성하지 않아도 됩니다.
              </div>
            </details>
            <details>
              <summary>
                <b>03</b>
                어떤 형태의 데이터를 연결할 수 있나요?
                <svg className="i">
                  <use href="#chev" />
                </svg>
              </summary>
              <div className="a">
                문서 파일부터 데이터베이스까지 다양한 형태의 데이터를 활용할 수 있습니다. 데이터의 종류와 관리 환경에 따라 연결 방식을 선택할 수 있으며, 자세한 지원 범위는 도입 상담을 통해 안내해 드립니다.
              </div>
            </details>
            <details>
              <summary>
                <b>04</b>
                기존 사내 시스템과 연동할 수 있나요?
                <svg className="i">
                  <use href="#chev" />
                </svg>
              </summary>
              <div className="a">
                네, 기존에 사용 중인 업무 시스템과의 연동도 검토할 수 있습니다. 시스템의 API 지원 여부와 보안 환경 등을 확인해 적합한 연동 방식과 적용 범위를 안내해 드립니다.
              </div>
            </details>
            <details>
              <summary>
                <b>05</b>
                관리자와 일반 사용자는 어떤 방식으로 이용하나요?
                <svg className="i">
                  <use href="#chev" />
                </svg>
              </summary>
              <div className="a">
                관리자와 일반 사용자가 각각의 역할에 맞는 환경에서 서비스를 이용할 수 있습니다. 관리자는 AI Agent의 생성과 운영, 사용자 및 권한 등을 관리하고, 일반 사용자는 제공된 AI Agent를 통해 필요한 업무를 수행합니다.
              </div>
            </details>
            <details>
              <summary>
                <b>06</b>
                클라우드 외에 사내 전용망 설치(온프레미스)도 가능한가요?
                <svg className="i">
                  <use href="#chev" />
                </svg>
              </summary>
              <div className="a">
                기업의 인프라와 보안 정책에 맞춰 구축 환경을 검토할 수 있습니다. 사내 전용망 설치가 필요한 경우, 현재 운영 환경과 요구사항을 확인한 뒤 지원 가능 여부와 구축 방식을 안내해 드립니다.
              </div>
            </details>
          </div>
        </div>
      </div>
    </section>
  );
}
